module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('bottom-toolbar'), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": "Contact Group Detail",
      "menuAccess": true,
      "returnPreviousPage": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [_c('div', {
    staticClass: "panel21 panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactGroupLabel),
      expression: "contactGroupLabel"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.contactGroupLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactGroupLabel = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("Contacts in this group")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(1) ? _c('ul', {
    staticClass: "list-group",
    attrs: {
      "disabled": ""
    }
  }, _vm._l((this.contactsArray), function(value) {
    return _c('li', {
      key: value.id,
      staticClass: "list-group-item"
    }, [_vm._v(_vm._s(value.label))])
  }), 0) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-start"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 height-button"
  }, [_c('button', {
    staticClass: "button-action",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.removeContactGroup
    }
  }, [_c('i', {
    staticClass: "icon fa fa-times-circle",
    staticStyle: {
      "font-size": "large"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Delete")])])])]), _vm._v(" "), _vm._m(3)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "content-block labelAccordionForm"
  }, [_c('i', {
    staticClass: "fa fa-address-book formIcon"
  }), _vm._v("\n                      Contact Group Details\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-5 col-sm-2 col-form-label"
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("Group name")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offset-md-5 col-md-3 height-button"
  }, [_c('button', {
    staticClass: "button-action ",
    attrs: {
      "round": ""
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "href": "/account/editContactGroup/"
    }
  }, [_c('i', {
    staticClass: "icon-edit icon icon-float-sub-button"
  }), _vm._v(" "), _c('span', [_vm._v("Edit contact group")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "toolbarPageBottomBlank"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e35fea9a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e35fea9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contacts/CMContactGroupDetail.vue
// module id = 1726
// module chunks = 2